module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov11-eeefbdde24ac661c838718467ee83de2.jpg";